import React from 'react';
import '../../stylesheets/app.scss';
import {
  NavigationBarAndMenu, Footer
} from '@library/shared-ui';

const Layout = ({ children }) => {
  return (
    <>
      <NavigationBarAndMenu
        featuredLinksMobileMenu={children.props.data.contentfulPageTemplate.navbarMenuSection.featuredLinksMobileMenu}
        mobileNavigationLinks={children.props.data.contentfulPageTemplate.navbarMenuSection.mobileNavigationLinks}
        featuredMobileSpot={children.props.data.contentfulPageTemplate.navbarMenuSection.featuredMobileSpot}
        ctaButtons={children.props.data.contentfulPageTemplate.navbarMenuSection.ctaButtons}
        logo={children.props.data.contentfulPageTemplate.navbarMenuSection.logo}
        navigationLinks={children.props.data.contentfulPageTemplate.navbarMenuSection.navigationLinks}
        showSearchSuggestions={false}
        searchSuggestions={null}
      />
      <main>
        {children}
      </main>
      <Footer
        columns={children.props.data.contentfulPageTemplate.footerSection.columns}
        infoColumn={children.props.data.contentfulPageTemplate.footerSection.infoColumn}
        logoContainer={children.props.data.contentfulPageTemplate.footerSection.logoContainer}
        bottomRow={children.props.data.contentfulPageTemplate.footerSection.bottomRow}
        pageContext={children.props.pageContext}
      />
    </>
  );
};

export default Layout;
